import { render, staticRenderFns } from "./attendeeCertificates.vue?vue&type=template&id=5601aa42&scoped=true&"
import script from "./attendeeCertificates.vue?vue&type=script&lang=js&"
export * from "./attendeeCertificates.vue?vue&type=script&lang=js&"
import style0 from "./attendeeCertificates.vue?vue&type=style&index=0&lang=css&"
import style1 from "./attendeeCertificates.vue?vue&type=style&index=1&id=5601aa42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5601aa42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\tavo\\source\\repos\\GEG\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5601aa42', component.options)
    } else {
      api.reload('5601aa42', component.options)
    }
    module.hot.accept("./attendeeCertificates.vue?vue&type=template&id=5601aa42&scoped=true&", function () {
      api.rerender('5601aa42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\views\\certificates\\attendeeCertificates.vue"
export default component.exports